<template>
  <div class="my">
    <div class="header">
      <img src="@/assets/mycoupon-banner.png" @click="cardbag">
      <div class="header-history" @click="$router.push({path: '/history'})">
        <img src="@/assets/icon_time.png" alt="">
        <span>观看历史</span>
        <span style="flex: 1;"></span>
        <span style="font-size: 0.384rem">查看历史观看记录></span>
      </div>
    </div>
    <div v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      class="list"
      style="flex: 1;overflow-y: auto;">
      <div class="item" v-for="(item, key) in list" :key="key" @click="clickOpen(item)">
        <img :src="item.cover_url_large">
        <div class="content">
            <div class="title">{{item.album_title}}</div>
            <div class="comment">{{item.album_intro | commentFilter}}</div>
            <!-- <div class="info">
                <img src="@/assets/icon_listen_blue.png">
                <span>{{item.play_count}}次播放</span>
            </div> -->
        </div>
      </div>
      <div v-show="alldata" class="nomore">--没有了哦--</div>
      <no-data v-show="nodata" :remark="'您还没有购买专辑，快去选购吧!!!'" />
    </div>
  </div>
</template>
<script>
import { InfiniteScroll } from 'mint-ui'
import { paySorce } from '@/api/pay'
import { openWindow, setTitle } from '@/api/app'
import { umtrack } from '@/utils/uweb'
import { substring } from '@/utils/index'
import NoData from '@/components/NoData'
export default {
  name: 'more',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    InfiniteScroll,
    NoData
  },
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  filters: {
    commentFilter(comment) {
      return substring(comment, 30, true)
    }
  },
  created () {
    var query = this.$route.query
    this.id = query.id
    this.template = query.template
    umtrack('blockView', {id: this.id, title: '书包'}, this)
  },
  mounted() {
    setTitle('书包');
  },
  data () {
    return {
      id: 0,
      template: '',
      loading: true,
      pageinfo: {
        current_page: 0
      },
      list: [],
      nodata: false,
      alldata: false
    }
  },
  methods: {
    loadMore: function () {
      if(this.pageinfo.current_page > 0 && this.pageinfo.current_page == this.pageinfo.last_page){
        return
      }
      this.loading = true;
      paySorce({id: this.id, page: (this.pageinfo.current_page + 1)}).then(response => {
        var data = response.data.data
        this.pageinfo = {
          current_page: data.current_page,
          last_page: data.last_page
        }
        if( data.current_page == data.last_page){
          this.alldata = true
        }
        this.list = this.list.concat(data.data)
        if(this.list.length < 1){
          this.nodata = true
        }
        this.loading = false;
      })
    },
    routerback: function () {
      this.$router.back(-1)
    },
    clickOpen: function(item){
      openWindow(0,'/play',{id: item.id},this)
    },
    cardbag() {
      this.$router.push({path: '/cardbag'})
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.my {
  height: 100vh;

  display: flex;
  flex-direction: column;
  .header{
    font-size: 16px;
    align-items: center;
    padding: 13px 16px;
    img{
      width: 100%;
    }
    .header-history{
      border-radius: 6px;
      background: linear-gradient(135deg, #EDD7BE 0%, #D5AF8A 100%);
      color: #945E28;
      padding: 10px 13px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      img{
        width: 18px;
        margin-right: 13px;
      }
    }
  }
  .list{
    padding: 16px;
    .nomore{
      font-size: 13px;
      color: #999
    }
  }
  .item{
    padding-bottom: 6px;
    border-radius: 6px;
    margin-bottom: 10px;
    display: flex;
    &>img{
      height: 92px;
      display: inherit;
      width: 92px;
      height: 60px;
      border-radius: 6px;
    }
    .content{
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0 0 0 13px;
      text-align: left;
      .title{
        font-size: 16px;
        font-weight: 600;
      }
      .comment{
        flex: 1;
        font-size: 13px;
        color: #999999;
        margin-bottom: 5px;
        padding: 6px 0;
      }
      .info{
        display: flex;
        align-items: center;
        color: #999999;
        img{
            margin-right: 6px;
        }
      }
    }
  }
}
</style>
